import React, { useRef, useEffect } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { VideoPlayerProps } from './types';

export function VideoPlayer({
  url,
  playing = false,
  controls = true,
  loop = false,
  muted = false,
  onEnded,
}: VideoPlayerProps): React.ReactElement {
  const isHls = url.toLowerCase().includes('.m3u8');

  if (!isHls) {
    return <NativeVideoPlayer url={url} playing={playing} controls={controls} loop={loop} muted={muted} onEnded={onEnded} />;
  }

  return <HlsVideoPlayer url={url} playing={playing} controls={controls} loop={loop} muted={muted} onEnded={onEnded} />;
}

function NativeVideoPlayer({
  url,
  playing,
  controls,
  loop,
  muted,
  onEnded,
}: VideoPlayerProps): React.ReactElement {
  return (
    <video
      src={url}
      controls={controls}
      autoPlay={playing}
      loop={loop}
      muted={muted}
      playsInline
      onEnded={onEnded}
      style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }}
    />
  );
}

function HlsVideoPlayer({
  url,
  playing = false,
  controls = true,
  muted = false,
  onEnded,
}: VideoPlayerProps): React.ReactElement {
  const videoRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current!.appendChild(videoElement);

      const player = playerRef.current = videojs(videoElement, {
        controls,
        autoplay: playing,
        muted,
        preload: 'auto',
        fill: true,
        sources: [{
          src: url,
          type: 'application/x-mpegURL',
        }],
      });

      if (onEnded) {
        player.on('ended', onEnded);
      }
    }

    return () => {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [url]);

  return <div ref={videoRef} style={{ width: '100%', height: '100%' }} />;
}
